<div class="block-header">
  <div class="row">
    <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 {{classLeft}}">
      <app-breadcrumb-v2 [titlePage]="titlePage" [count]="count"></app-breadcrumb-v2>
      <button *ngIf="showBtnStatus" type="button" (click)="onClose()" class="btn btn-default"><i class="fa fa-globe"></i> {{ 'VISIBLE.TO.ANYONE' | translate }}</button>
    </div>
    <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 {{classRight}}">
      <div class="breadcrumb-button {{classRight}}">
        <button *ngIf="showBtnCancel" type="button" (click)="onClose()" class="btn btn-danger"><i class="fa fa-reply"></i> {{ enumText.Cancel }}</button>&nbsp;&nbsp;
        <button *ngIf="showBtnSaveChanges && addOrEditButton" [disabled]="disabledBtnSaveChanges()" type="submit" class="btn btn-primary" value="Save" ><i class="fa fa-save"></i> {{enumText.SaveChanges}}</button>&nbsp;&nbsp;
        <button *ngIf="showBtnAddNew" type="button" (click)="onAdd()" class="btn btn-info" ><i class="fa fa-plus"></i> {{enumText.New}}</button>
      </div>
    </div>
  </div>
</div>
